var {
  useRadioGroupState
} = require("@react-stately/radio");

var {
  useProviderProps
} = require("@react-spectrum/provider");

var {
  useFormProps
} = require("@react-spectrum/form");

var {
  Label
} = require("@react-spectrum/label");

var {
  useRadio,
  useRadioGroup
} = require("@react-aria/radio");

var {
  useHover
} = require("@react-aria/interactions");

var _react2 = require("react");

var _react = $parcel$interopDefault(_react2);

var {
  forwardRef,
  useRef,
  useContext
} = _react2;

var {
  FocusRing
} = require("@react-aria/focus");

var {
  classNames,
  useFocusableRef,
  useStyleProps,
  useDOMRef
} = require("@react-spectrum/utils");

var _babelRuntimeHelpersObjectWithoutPropertiesLoose = $parcel$interopDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/radio/vars.css
var $b50b26895e9d451b27b55d215ff6a51$exports = {};
$b50b26895e9d451b27b55d215ff6a51$exports = {
  "spectrum-Radio": "_spectrum-Radio_db05c",
  "spectrum-Radio-input": "_spectrum-Radio-input_db05c",
  "spectrum-Radio-button": "_spectrum-Radio-button_db05c",
  "focus-ring": "_focus-ring_db05c",
  "spectrum-Radio-label": "_spectrum-Radio-label_db05c",
  "spectrum-Radio--labelBelow": "_spectrum-Radio--labelBelow_db05c",
  "is-hovered": "_is-hovered_db05c",
  "spectrum-Radio--quiet": "_spectrum-Radio--quiet_db05c",
  "is-invalid": "_is-invalid_db05c"
};

const $dc0e5d54409e9454b207deef7914e49$export$RadioContext = /*#__PURE__*/_react.createContext(null);

function $dc0e5d54409e9454b207deef7914e49$export$useRadioProvider() {
  return useContext($dc0e5d54409e9454b207deef7914e49$export$RadioContext);
}

var $b50b26895e9d451b27b55d215ff6a51$$interop$default = $parcel$interopDefault($b50b26895e9d451b27b55d215ff6a51$exports);

function $e743ac5588e53ffd4700c60556426f6$var$Radio(props, ref) {
  let {
    isDisabled,
    children,
    autoFocus
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["isDisabled", "children", "autoFocus"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let {
    hoverProps,
    isHovered
  } = useHover({
    isDisabled
  });
  let inputRef = useRef(null);
  let domRef = useFocusableRef(ref, inputRef);
  let radioGroupProps = $dc0e5d54409e9454b207deef7914e49$export$useRadioProvider();
  let {
    isEmphasized,
    validationState,
    state
  } = radioGroupProps;
  let {
    inputProps
  } = useRadio(_babelRuntimeHelpersExtends({}, props, radioGroupProps, {
    isDisabled
  }), state, inputRef);
  return /*#__PURE__*/_react.createElement("label", _babelRuntimeHelpersExtends({}, styleProps, hoverProps, {
    ref: domRef,
    className: classNames($b50b26895e9d451b27b55d215ff6a51$$interop$default, 'spectrum-Radio', {
      // Removing. Pending design feedback.
      // 'spectrum-Radio--labelBelow': labelPosition === 'bottom',
      'spectrum-Radio--quiet': !isEmphasized,
      'is-disabled': isDisabled,
      'is-invalid': validationState === 'invalid',
      'is-hovered': isHovered
    }, styleProps.className)
  }), /*#__PURE__*/_react.createElement(FocusRing, {
    focusRingClass: classNames($b50b26895e9d451b27b55d215ff6a51$$interop$default, 'focus-ring'),
    autoFocus: autoFocus
  }, /*#__PURE__*/_react.createElement("input", _babelRuntimeHelpersExtends({}, inputProps, {
    ref: inputRef,
    className: classNames($b50b26895e9d451b27b55d215ff6a51$$interop$default, 'spectrum-Radio-input')
  }))), /*#__PURE__*/_react.createElement("span", {
    className: classNames($b50b26895e9d451b27b55d215ff6a51$$interop$default, 'spectrum-Radio-button')
  }), children && /*#__PURE__*/_react.createElement("span", {
    className: classNames($b50b26895e9d451b27b55d215ff6a51$$interop$default, 'spectrum-Radio-label')
  }, children));
}
/**
 * Radio buttons allow users to select a single option from a list of mutually exclusive options.
 * All possible options are exposed up front for users to compare.
 */


const Radio = /*#__PURE__*/forwardRef($e743ac5588e53ffd4700c60556426f6$var$Radio);
exports.Radio = Radio;
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/fieldlabel/vars.css
var $a0bedb1888ff92cb3407d1a60d76e$exports = {};
$a0bedb1888ff92cb3407d1a60d76e$exports = {
  "spectrum-FieldLabel": "_spectrum-FieldLabel_36b9b",
  "spectrum-FieldLabel--positionSide": "_spectrum-FieldLabel--positionSide_36b9b",
  "spectrum-FieldLabel-requiredIcon": "_spectrum-FieldLabel-requiredIcon_36b9b",
  "spectrum-FieldLabel--alignEnd": "_spectrum-FieldLabel--alignEnd_36b9b",
  "spectrum-Field": "_spectrum-Field_36b9b",
  "spectrum-Field--positionTop": "_spectrum-Field--positionTop_36b9b",
  "spectrum-Field-field": "_spectrum-Field-field_36b9b",
  "spectrum-Field-field--multiline": "_spectrum-Field-field--multiline_36b9b",
  "spectrum-Field--positionSide": "_spectrum-Field--positionSide_36b9b",
  "spectrum-Form": "_spectrum-Form_36b9b",
  "spectrum-Form--positionSide": "_spectrum-Form--positionSide_36b9b",
  "spectrum-Form--positionTop": "_spectrum-Form--positionTop_36b9b",
  "spectrum-Form-itemLabel": "_spectrum-Form-itemLabel_36b9b",
  "is-disabled": "_is-disabled_36b9b"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/fieldgroup/vars.css
var $ddc491461af2b6836404526ae99891$exports = {};
$ddc491461af2b6836404526ae99891$exports = {
  "spectrum-FieldGroup": "_spectrum-FieldGroup_8cb9b",
  "spectrum-FieldGroup--positionSide": "_spectrum-FieldGroup--positionSide_8cb9b",
  "spectrum-FieldGroup-group": "_spectrum-FieldGroup-group_8cb9b",
  "spectrum-FieldGroup-group--horizontal": "_spectrum-FieldGroup-group--horizontal_8cb9b"
};
var $ddc491461af2b6836404526ae99891$$interop$default = $parcel$interopDefault($ddc491461af2b6836404526ae99891$exports);
var $a0bedb1888ff92cb3407d1a60d76e$$interop$default = $parcel$interopDefault($a0bedb1888ff92cb3407d1a60d76e$exports);

function $e125f55143423f8d3ecf034e5ae37$var$RadioGroup(props, ref) {
  props = useProviderProps(props);
  props = useFormProps(props);

  let {
    isEmphasized,
    isRequired,
    necessityIndicator,
    label,
    labelPosition = 'top',
    labelAlign,
    validationState,
    children,
    orientation = 'vertical'
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["isEmphasized", "isRequired", "necessityIndicator", "label", "labelPosition", "labelAlign", "validationState", "children", "orientation"]);

  let domRef = useDOMRef(ref);
  let {
    styleProps
  } = useStyleProps(otherProps);
  let state = useRadioGroupState(props);
  let {
    radioGroupProps,
    labelProps
  } = useRadioGroup(props, state);
  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, styleProps, radioGroupProps, {
    className: classNames($ddc491461af2b6836404526ae99891$$interop$default, 'spectrum-FieldGroup', {
      'spectrum-FieldGroup--positionSide': labelPosition === 'side'
    }, // This is so radio works inside a <Form>
    classNames($a0bedb1888ff92cb3407d1a60d76e$$interop$default, 'spectrum-Field'), styleProps.className),
    ref: domRef
  }), label && /*#__PURE__*/_react.createElement(Label, _babelRuntimeHelpersExtends({}, labelProps, {
    elementType: "span",
    labelPosition: labelPosition,
    labelAlign: labelAlign,
    isRequired: isRequired,
    necessityIndicator: necessityIndicator
  }), label), /*#__PURE__*/_react.createElement("div", {
    className: classNames($ddc491461af2b6836404526ae99891$$interop$default, 'spectrum-FieldGroup-group', {
      'spectrum-FieldGroup-group--horizontal': orientation === 'horizontal'
    })
  }, /*#__PURE__*/_react.createElement($dc0e5d54409e9454b207deef7914e49$export$RadioContext.Provider, {
    value: {
      isEmphasized,
      isRequired,
      validationState,
      state
    }
  }, children)));
}
/**
 * Radio groups allow users to select a single option from a list of mutually exclusive options.
 * All possible options are exposed up front for users to compare.
 */


const RadioGroup = /*#__PURE__*/_react.forwardRef($e125f55143423f8d3ecf034e5ae37$var$RadioGroup);

exports.RadioGroup = RadioGroup;
